import Card, { CardContent } from 'components/Card';
import Link from 'components/Link';
import React, { ReactNode } from 'react';
import styles from './PageContainer.module.css';

export interface BreadcrumbProps {
  as?: string;
  href: string;
  title: string;
}
export interface PageContainerProps {
  breadcrumbs: BreadcrumbProps[];
  children: ReactNode;
  cmsContent?: boolean;
  footer?: ReactNode;
  hasLargePadding?: boolean;
  pageTitle?: string;
  preTitle?: ReactNode;
  title?: ReactNode;
}

export function PageContainer({ breadcrumbs, children, cmsContent, pageTitle, preTitle, title: pageContainerHeading }: PageContainerProps) {
  const Header = () => {
    return (
      <>
      <div className={styles['PageContainer--Header']}>
        <div className={styles['PageContainer--Title']}>
          {pageContainerHeading && (
            <h2 className='c-tag h6'>{pageContainerHeading}</h2>
          )}
          <h1 className='h-font--primary h-font--uppercase h2 c-text--underline'>{pageTitle}</h1>
        </div>
      </div>
      </>
    );
  };

  const Content = () => (cmsContent ? <div className={styles['CMSContent']}>{children}</div> : <CardContent>{children}</CardContent>);

  return (
    <Card className={styles['PageContainer']} header={<Header />} transparent>
      <Content />
    </Card>
  );
}
